import { getGlobalObject } from './getGlobalObject';
/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 */
export function getZoneJsOriginalDom(target, name) {
    const browserWindow = getGlobalObject();
    let original;
    if (browserWindow.Zone &&
        typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
